import React from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline } from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import LoginContextProvider from './Components/Providers/LoginContextProvider';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Amplify from 'aws-amplify';
import awsconfig from "./aws-exports"


Amplify.configure(awsconfig);

const muiTheme = createMuiTheme({
  palette: {
    background: {
      default: "#f5f5f5"
    },
  },
  typography: {
    fontFamily: '"Roboto","M PLUS Rounded 1c" '
  }
})

ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider theme={muiTheme}>
      <LoginContextProvider>
        <CssBaseline />
        <App />
      
      </LoginContextProvider>
    </MuiThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
